import React, { useRef, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import TelegramIcon from "@material-ui/icons/Telegram";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import "@metricell/smarttoolscore/dist/module/Styles/metricell.css";

export interface IShareProps {
    link: string;
    name: string;
}

export interface IContacts {
    userId: string;
    fullName: string;
    profileImage: string;
}

export const ViewShareSharing: React.FunctionComponent<IShareProps> = (
    props,
): React.ReactElement => {
    const [messengerShare, setMessengerShare] = useState<boolean>(false),
        [contactSelected, setContactSelected] = useState<boolean>(false),
        defaultMessage = `Hi, I would like to share my view with you by clicking on this link: `,
        searchContacts = useRef<HTMLInputElement>(null),
        [userContacts, setUserContacts] = useState<IContacts[]>([]),
        [message, setMessage] = useState<string>(defaultMessage),
        [searchTerm, setSearchTerm] = useState<string>(``),
        [contact, setContact] = useState<IContacts>(null);

    const sendEmailonClick = (): void => {
        const mail = document.createElement("a");

        mail.href = `mailto:?subject=View Share: ${props.name}&body=${message} ${props.link}`;
        mail.click();
    };

    return (
        <div>
            {!messengerShare && (
                <div className={`sharing-options`}>
                    <div
                        onClick={(): void => {
                            sendEmailonClick();
                        }}
                    >
                        <p>Share Via Email</p>
                    </div>
                </div>
            )}
            {messengerShare && (
                <div className={`sharing-container`}>
                    <div className={`sharing-searcharea`}>
                        <input
                            onChange={(e): void => {
                                setSearchTerm(e.target.value);
                            }}
                            placeholder={`Search contacts`}
                            ref={searchContacts}
                        />
                    </div>
                    <div className={`sharing-content`}>
                        <div className={`contacts-container`}>
                            <div className={`scroll`}>
                                {userContacts
                                    ?.filter((c) =>
                                        c.fullName
                                            .toUpperCase()
                                            .includes(searchTerm.toUpperCase()),
                                    )
                                    ?.map((scontact) => (
                                        <div
                                            className={`sharing-contact ${
                                                scontact?.fullName ===
                                                contact?.fullName
                                                    ? ` viewshare-selected`
                                                    : ``
                                            }`}
                                            key={scontact.fullName}
                                            onClick={(): void => {
                                                setContactSelected(true);
                                                setContact(scontact);
                                            }}
                                        >
                                            <img
                                                src={
                                                    scontact?.profileImage
                                                        ? scontact?.profileImage
                                                        : `/Images/DefaultProfilePic.svg`
                                                }
                                            />
                                            <p>
                                                {scontact?.fullName.replace(
                                                    `.`,
                                                    ` `,
                                                )}
                                            </p>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
